import { el } from 'date-fns/locale'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      toRoute: null,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'unsavedData']),
  },
  beforeCreate() {
    this.$root.$off('cancelTabNavigation')
  },
  created() {
    this.$root.$on('cancelTabNavigation', () => {
      this.selectedTab = this.activeTab
    })
  },
  methods: {
    //
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.$root._events[`checkDataChanged${from.name}`] &&
      this.unsavedData &&
      to.name !== 'login'
    ) {
      await this.$root.$emit(`checkDataChanged${from.name}`, to)
      if (this.unsavedData) {
        next(false)
      } else {
        next()
      }
    } else {
      next()
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (
      this.$root._events[`checkDataChanged${from.name}`] &&
      this.unsavedData &&
      to.name !== 'login'
    ) {
      await this.$root.$emit(`checkDataChanged${from.name}`, to)
      if (this.unsavedData) {
        next(false)
      } else {
        next()
      }
    } else {
      next()
    }
  },
}
